var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E7DE16"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.166 23.5007H21.8327",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0456 18.4775C10.2873 18.2283 8.17478 15.7433 8.54145 12.8483C8.86061 10.3225 11.1423 8.5 13.6889 8.5H18.4998C21.3123 8.5 23.5823 10.8225 23.4973 13.6542C23.4156 16.3908 21.0273 18.5 18.2898 18.5H16.1564C15.5014 19.1542 14.5656 20.0908 13.7556 20.9008C13.4931 21.1633 13.0456 20.9767 13.0456 20.605V18.4775Z",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1482 13.56C16.2298 13.6417 16.2298 13.7734 16.1482 13.855C16.0665 13.9367 15.9348 13.9367 15.8532 13.855C15.7715 13.7734 15.7715 13.6417 15.8532 13.56C15.9348 13.4784 16.0665 13.4792 16.1482 13.56",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4802 13.56C19.5618 13.6417 19.5618 13.7734 19.4802 13.855C19.3985 13.9367 19.2668 13.9367 19.1852 13.855C19.1035 13.7734 19.1035 13.6417 19.1852 13.56C19.2668 13.4784 19.3985 13.4792 19.4802 13.56",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8142 13.56C12.8958 13.6417 12.8958 13.7734 12.8142 13.855C12.7325 13.9367 12.6008 13.9367 12.5192 13.855C12.4375 13.7734 12.4375 13.6417 12.5192 13.56C12.6008 13.4784 12.7325 13.4792 12.8142 13.56",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchIcon);
export default __webpack_public_path__ + "static/media/WatchIcon.1bcfbca75ae6544efb79642e013adf4a.svg";
export { ForwardRef as ReactComponent };